import NamedDto from 'modules/base/dto/NamedDto';

export default class LabConnectionTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.hostName = null;
		/** @type {string} */
		this.databaseName = null;
		/** @type {string} */
		this.user = null;
	}

	/**
	 * @typedef {Object} _LabConnectionTableDtoProps
	 * @property {string} hostName
	 * @property {string} databaseName
	 * @property {string} user
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _LabConnectionTableDtoProps} LabConnectionTableDtoProps
	 */
	/**
	 *
	 * @param {LabConnectionTableDtoProps} props
	 * @returns {LabConnectionTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.hostName = props?.hostName;
		this.databaseName = props?.databaseName;
		this.user = props?.user;
		return this;
	}
}
